module.exports = __webpack_public_path__ + "img/join-us-tijian.d6d1cf55.png";